<template>
  <DashboardHeader>
    <v-layout row wrap>
      <v-flex xs12 class="mx-4">
        <v-data-table
          :headers="headers"
          :items="allTopics"
          sort-by="name"
          class="elevation-20"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Topics</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>

              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">Create Topic</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <ValidationObserver>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="4">
                            <ValidationProvider
                              v-slot="{ errors }"
                              name="Topic"
                              rules="required|max:100"
                            >
                              <v-text-field
                                v-model="editedItem.name"
                                label="Topic"
                                :error-messages="errors"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>

                          <v-col cols="12" sm="6" md="4">
                            <ValidationProvider
                              v-slot="{ errors }"
                              name="Description"
                              rules="required"
                            >
                              <v-text-field
                                v-model="editedItem.description"
                                label="Description"
                                :error-messages="errors"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>

                          <v-col cols="12" sm="12" md="12">
                            <ValidationProvider
                              v-slot="{ errors }"
                              name="Subject ID"
                              rules="required|max:100"
                            >
                              <v-select
                                v-model="editedItem.subId"
                                :items="subjects"
                                :rules="[v => !!v || 'Item is required']"
                                label="Subject ID"
                                :error-messages="errors"
                                required
                              ></v-select>
                            </ValidationProvider>
                          </v-col>

                          <v-col cols="12" sm="12" md="12">
                            <ValidationProvider
                              v-slot="{ errors }"
                              name="Teaching Plan"
                              rules="required|max:100"
                            >
                              <v-textarea
                                clearable
                                v-model="editedItem.atp"
                                clear-icon="cancel"
                                :error-messages="errors"
                                label="Teaching Plan"
                              ></v-textarea>
                            </ValidationProvider>
                          </v-col>

                          <input type="hidden" v-model="editedItem.topicId" />
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </ValidationObserver>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </DashboardHeader>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader";
import { required, email, max } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";
import axios from "@/plugins/axios";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} can not be empty"
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters"
});

extend("email", {
  ...email,
  message: "Email must be valid"
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    DashboardHeader
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  mounted() {
    axios.getData("/auth/all-subjects", this.getAccessToken).then(response =>
      response.forEach(subject =>
        this.subjects.push({
          text: subject.name + " [" + subject.grades.name + " ]",
          value: subject.subject_id
        })
      )
    );
  },

  created() {
    this.$store.commit("setLoader", true);
    this.initialize();
    this.$store.commit("setLoader", false);
  },
  data: () => ({
    topicATP: "This is the topic teaching plan.",
    allTopics: [],
    dialog: false,

    subjects: [],

    search: "",
    headers: [
      {
        text: "Topic",
        align: "start",
        sortable: false,
        value: "name"
      },
      { text: "Description", value: "description" },

      { text: "Teaching Plan", value: "atp" },
      { text: "Actions", value: "actions", sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      name: "Topic",
      description: "Description",
      subId: "Sud ID 123",
      atp: "Teaching Plan",
      topicId: ""
    },
    defaultItem: {
      name: "Topic",
      description: "Description",
      subId: "Sud ID 123",
      atp: "Teaching Plan"
    }
  }),

  methods: {
    initialize() {
      axios
        .getData("/auth/all-topics", this.getAccessToken)
        .then(response => (this.allTopics = response));
    },

    editItem(item) {
      this.editedIndex = this.allTopics.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.subId = {
        text: this.editedItem.subject_id,
        value: this.editedItem.subject_id
      };
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        //this.allTopics.splice(index, 1)
        axios
          .postDataWithToken(
            "/auth/delete-item",
            { table: "topics", id: item.id },
            this.getAccessToken
          )
          .then(() => this.initialize());
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        //Edit and Save in Database
        axios
          .postDataWithToken(
            "/auth/edit-topic",
            {
              name: this.editedItem.name,
              description: this.editedItem.description,
              atp: this.editedItem.atp,
              subId: this.editedItem.subject_id,
              topicId: this.editedItem.topic_id
            },
            this.getAccessToken
          )
          .then(() => this.initialize());
      } else {
        //Save in Database
        axios
          .postDataWithToken(
            "/auth/create-topic",
            {
              name: this.editedItem.name,
              description: this.editedItem.description,
              atp: this.editedItem.atp,
              subId: this.editedItem.subId
            },
            this.getAccessToken
          )
          .then(response => this.allTopics.push(response));
      }

      this.close();
    },

    clear() {
      this.name = "";
      this.email = "";
      this.select = null;
      this.checkbox = null;
      this.$refs.observer.reset();
    }
  }
};
</script>